import React from 'react'
import { useSelector } from 'react-redux'

import { Collapsable } from 'components/UI'
import { Input } from 'components/Forms'

/**
 * Function that returns which fields to use for the pay codes
 * @param {string} payExportType which pay report the company uses
 * @returns {array} array of pay fields to use
 */
export const getPaycodeInitialValues = payExportType => {
  switch (payExportType) {
    case 'nethrisEmployeurD':
      return ['regularEarningCode', 'hourlyRate', 'division', 'service', 'department', 'subDepartment', 'workS1', 'workS2']
    case 'apogee':
      return ['funcCode', 'functLevel']
    default:
      return []
  }
}

const PayCodes = ({ type }) => {
  const { payExportType, payCodeEquivalences = {} } = useSelector(state => state.settings)

  if (!['nethrisEmployeurD', 'apogee'].includes(payExportType)) return null

  // Find out which fields to show for this resource type
  const payCodeValues = getPaycodeInitialValues(payExportType).filter(value => {
    return payCodeEquivalences[value] === type
  })

  if (!payCodeValues.length) return null

  return (
    <Collapsable type={`${payExportType}Codes`} title={`components.payCodes.${payExportType}.TITLE`}>
      {payCodeValues.map(field => (
        <Input key={field} module={`components.payCodes.${payExportType}`} translation={field} name={`payCodes.${field}`} />
      ))}
    </Collapsable>
  )
}

export default PayCodes
